<template functional>
  <div v-if="$options.amountAsNumber(props.amount) > 0 || props.allowNeutralNegative" :class="['relative pr-8 text-right', { 'text-left inline-block' : props.isAlignLeft }]">
    <i18n-n :class="[{ 'font-semibold' : props.amountIsBold }]" :value="$options.amountAsNumber(props.amount)" :format="$options.getFormat(props.currency)" tag="div" />
    <div class="absolute bottom-0 right-0 text-xs font-normal leading-5">
      {{ props.currency }}
    </div>
  </div>
</template>

<script>

const formats = {
  'JPY': { minimumFractionDigits: 0 },
  'default': { style: 'decimal', minimumFractionDigits: 2 }
}

export default {
  name: 'BaseAmount',

  props: {
    amount: {
      required: true,
      type: [Number, String]
    },
    amountIsBold: {
      type: Boolean,
      default: false
    },
    currency: {
      required: true,
      type: String
    },
    isAlignLeft: {
      type: Boolean,
      default: false
    },
    allowNeutralNegative: {
      type: Boolean,
      default: false
    }
  },

  amountAsNumber (amount) {
    return (typeof amount !== 'number' ? Number(amount) : amount)
  },

  getFormat (currency) {
    return (formats[currency] || formats['default'])
  }
}
</script>
